module.exports = __webpack_public_path__ + "media/images/casino-ee66f5d52083c80b822ea5600b5251af.svg";